import React from "react";

const PatientAck = () => {
  return (
    <div className="bg-gray-10 border-1 border-gray-100 p-2 flex flex-col items-start max-w-[281px]">
      <p className="text-teal-300 text-sm font-normal text-left">
        The completed form replaces the patient signature on the final Personal Medication Record.
      </p>
    </div>
  );
};

export default PatientAck;